import React, { FC } from 'react'

import { X } from 'lucide-react'

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select'

import {
  IRegistrationByDayInterface,
  IScoreStatus,
} from '../../../models/registrations-by-day/registrationByDay.interface'

import { scoreStatusOptions } from '../../../const/score-card-const'

interface ScoreStatusSelectProps {
  value: IRegistrationByDayInterface
  setValue: (value: IRegistrationByDayInterface) => void
  editable?: boolean
  isLocked: boolean
  showLockedModal: () => void
}
export const ScoreStatusSelect: FC<ScoreStatusSelectProps> = ({
  value,
  setValue,
  editable,
  isLocked,
  showLockedModal,
}) => {
  return (
    <div className="ml-auto min-w-[150px] flex items-center gap-2.5 justify-end">
      <Select
        key={value.score?.scoreStatus ? 'active' : 'empty'}
        name="scoreStatus"
        disabled={!editable}
        value={(value.score?.scoreStatus as IScoreStatus) || undefined}
        onValueChange={(status) => {
          value.score = {
            ...value.score,
            scoreStatus: status as IScoreStatus,
          }
          setValue({ ...value })
        }}
      >
        <SelectTrigger
          className="ml-auto border-none p-0 text-base"
          onPointerDown={(e) => {
            if (isLocked) {
              e.preventDefault()
              e.stopPropagation()
              showLockedModal()
            }
          }}
        >
          <SelectValue placeholder="Select status..." />
          {value?.score?.scoreStatus && (
            <button
              type="button"
              className="opacity-50 hover:opacity-100 transition-all"
              onPointerDown={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
              onClick={() => {
                if (isLocked) {
                  showLockedModal()
                  return
                }
                value.score = {
                  ...value.score,
                  scoreStatus: null,
                }
                setValue({ ...value })
              }}
            >
              <X className="!w-3 !h-3" />
            </button>
          )}
        </SelectTrigger>
        <SelectContent className="max-h-[500px]">
          {scoreStatusOptions?.map((day) => (
            <SelectItem key={day.value} value={day.value}>
              {day.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
